import { Layout, ThemeConfig } from "antd";
import Header from "../molecules/Header";
import { Outlet } from "react-router";
import { ReactNode, CSSProperties, useMemo } from "react";
import useIsMobile from "../../utils/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../configureStore";

interface SharedLayoutProps {
    logo?: string;
    isTest?: boolean;
    children?: ReactNode;
    noHeader?: boolean;
}

const SharedLayout = ({
    logo,
    isTest = false,
    noHeader = false,
    children,
}: SharedLayoutProps) => {
    const isMobile = useIsMobile();
    const antdConfig = useSelector<RootState, ThemeConfig>(({ configuration }) => configuration.antdConfig);

    const styles: Record<string, CSSProperties> = useMemo(() => ({
        layout: {
            minHeight: '100vh',
            backgroundColor: antdConfig?.token?.colorBgLayout ?? '#f5f5f5',
        },
        content: {
            paddingRight: isMobile ? '4px' : '24px',
            paddingLeft: isMobile ? '4px' : '24px',
            paddingTop: '24px',
            paddingBottom: '24px',
            margin: 0,
            minHeight: 'calc(100vh - 64px)',
            backgroundColor: 'transparent',
        },
    }), [isMobile, antdConfig]);


    const layoutStyle = isTest ? {} : styles.layout;

    return (
        <Layout style={layoutStyle}>
            {!noHeader && <Header logo={logo} isTest={isTest} />}
            <Layout.Content style={styles.content}>
                {children ?? <Outlet />}
            </Layout.Content>
        </Layout>
    );
};

export default SharedLayout;
